export enum FeatureBrandTileExperimentVariants {
	Off = 'off',
	Control = 'control',
	V1 = 'v1',
	V2 = 'v2',
}
